import TreeTable from "./tree-table.jsx";

export default TreeTable;